import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  fetchReportHistoryFail,
  fetchReportHistorySuccess,
  FETCH_REPORT_HISTORY
} from '../../redux/actions/cm/caseReportHistory';
import { fetchStrReportHistoryForCase } from '../../services/cm/historyItems';

function* fetchReportHistoryWorker({ reportId, currentHistoryPage }) {
  try {
    const { events, totalCount } = yield call(fetchStrReportHistoryForCase, {
      reportId,
      currentHistoryPage
    });
    yield put(fetchReportHistorySuccess({ list: events, total: totalCount }));
  } catch (error) {
    yield put(fetchReportHistoryFail());
  }
}

export function* watchReportfetchHistory() {
  yield takeEvery(
    FETCH_REPORT_HISTORY,
    function* ({ payload: { reportId, currentHistoryPage } }) {
      yield fork(fetchReportHistoryWorker, { reportId, currentHistoryPage });
    }
  );
}
